import {ServiceProviderRepository} from '../repository/ServiceProviderRepository';

export class UnassignBrandFromProviderUseCase {
  constructor (private repo: ServiceProviderRepository) {}

  async execute (providerId: number, brandId: number): Promise<any> {
    return this.repo.unassignBrand(providerId, brandId);
  }
}
